import React from 'react';
import classNames from 'classnames/bind';

import { DataBlocks, Heading, I18n, I18nRaw, Icon } from 'components';

import styles from '../../styles.pcss';
import { useDataFromOffice } from '../../../../hooks/useDataFromOffice';

const cx = classNames.bind(styles);

const UpdateDataFromOffice = () => {
  const { descriptionThirdCase } = useDataFromOffice();

  return (
    <DataBlocks.Container>
      <Icon name="gps" className={cx('caseIcon')} />
      <div className={cx('case')}>
        <Heading level={4} tagName="h5" className={cx('caseHeading')}>
          <I18n path="settings.passportUpload.headingThirdCase" />
        </Heading>
        <I18nRaw className={cx('caseDescription')} html={descriptionThirdCase} />
      </div>
    </DataBlocks.Container>
  );
};

export default UpdateDataFromOffice;
